import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectBalancingCoopDescriptionCharAmount, selectBalancingCoopUnlockLevel, } from "../../../balancingSelectors/selectBalancingConstants";
import { selectCoopFoundCost } from "../../../balancingSelectors/selectBalancingCoopSettings";
import { IdErrorCore } from "../../../constants/IdErrorCore";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopFoundLanguage } from "../../../selectors/selectCoopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { CoopJoinPolicyType, StatusCode, } from "../../../utils/network/generated/protoTypes";
import { actionErrorResolveError } from "../../errors/actionError";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { mapTextError } from "../../set-player-name/mapTextError";
import { actionCoopEditCoop, actionCoopFoundCoop, actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
import { FoundEditBtns } from "./FoundEditBtns";
import { FoundEditNameAndDescription } from "./FoundEditNameAndDescription";
import { FoundEditOptions } from "./FoundEditOptions";
export var _TabCoopFoundEdit = function (_a) {
    var coop = _a.coop, errorStatusCode = _a.errorStatusCode, onFilterMenuClick = _a.onFilterMenuClick, onCreateCoop = _a.onCreateCoop, onUpdateCoop = _a.onUpdateCoop, onErrorResolve = _a.onErrorResolve, selectedCoopFoundLanguage = _a.selectedCoopFoundLanguage, onCancelUpdate = _a.onCancelUpdate;
    var _b = useState(""), coopName = _b[0], setCoopName = _b[1];
    var coopFoundCost = selectCoopFoundCost();
    var charLimit = selectBalancingCoopDescriptionCharAmount();
    var _c = useState(coop ? coop.description : ""), coopDescription = _c[0], setCoopDescription = _c[1];
    var _d = useState(IdLoca.empty), coopErrorLoca = _d[0], setCoopErrorLoca = _d[1];
    var coopState = "Open";
    var coopRequiredLevel = coop && coop.minLevel ? coop.minLevel : selectBalancingCoopUnlockLevel();
    var _e = useState(coopRequiredLevel), coopLevel = _e[0], setCoopLevel = _e[1];
    useEffect(function () {
        if (errorStatusCode) {
            setCoopErrorLoca(mapTextError.get(errorStatusCode) || IdLoca.empty);
        }
    });
    var onConfirmClick = function () {
        if (errorStatusCode) {
            onErrorResolve();
        }
        if (coopName.length === 0) {
            setCoopErrorLoca(IdLoca.error_atLeastOneLetter);
            return;
        }
        onCreateCoop(coopDescription, CoopJoinPolicyType.JOINABLE, selectedCoopFoundLanguage.languageCode, coopLevel, coopName);
    };
    var onUpdateClick = function () {
        if (errorStatusCode) {
            onErrorResolve();
        }
        if (coop) {
            onUpdateCoop(coopDescription, CoopJoinPolicyType.JOINABLE, selectedCoopFoundLanguage.languageCode, coopLevel, coop.id);
        }
    };
    return (React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around w100 h100" },
        React.createElement("div", { className: "flex w100 flex--around" },
            React.createElement("div", { className: IdStyles.CoopFoundGraphicsContainer + " flex flex--aligned flex--centered margin--large" },
                React.createElement("div", { className: "big-coop-picture big-coop-picture__coop" })),
            React.createElement(FoundEditNameAndDescription, { coopName: coopName, setCoopName: setCoopName, coopDescription: coopDescription, setCoopDescription: setCoopDescription, coopErrorLoca: coopErrorLoca, coop: coop, charLimit: charLimit, onSubmit: coop ? onUpdateClick : onConfirmClick })),
        React.createElement(FoundEditOptions, { coop: coop, coopState: coopState, coopRequiredLevel: coopLevel, onFilterMenuClick: onFilterMenuClick, onChangeRequiredLevel: setCoopLevel, selectedFilterLanguage: selectedCoopFoundLanguage }),
        React.createElement(FoundEditBtns, { coop: coop, onConfirmClick: onConfirmClick, onUpdateClick: onUpdateClick, coopFoundCost: coopFoundCost, onUpdateCancel: onCancelUpdate })));
};
var mapState = function (state) {
    var errorStatusCode = state.errors.TextErrors.length > 0
        ? state.errors.TextErrors[state.errors.TextErrors.length - 1]
        : StatusCode.Undefined;
    return {
        coop: state.coopInfo.coop,
        errorStatusCode: errorStatusCode,
        selectedCoopFoundLanguage: selectCoopFoundLanguage(state),
    };
};
var mapDispatch = function (dispatch) { return ({
    onCancelUpdate: function () {
        dispatch(actionCoopMenuSetFirstTab(IdCoopCategory.CoopInfoView));
        dispatch(actionCoopMenuTabGoTo(IdCoopCategory.CoopInfoView));
    },
    onCreateCoop: function (description, joinPolicy, language, minLevel, name) {
        return dispatch(actionCoopFoundCoop(description, joinPolicy, language, minLevel, name));
    },
    onErrorResolve: function () { return dispatch(actionErrorResolveError(IdErrorCore.TextErrors)); },
    onFilterMenuClick: function () { return dispatch(actionModalOpen(IdModal.CoopLanguageFilter)); },
    onUpdateCoop: function (description, joinPolicy, language, minLevel, coopId) {
        return dispatch(actionCoopEditCoop(description, joinPolicy, language, minLevel, coopId));
    },
}); };
export var TabCoopFoundEdit = connect(mapState, mapDispatch)(_TabCoopFoundEdit);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/found-edit/TabCoopFoundEdit.tsx
// module id = 2581
// module chunks = 3